module.exports = __webpack_public_path__ + "static/media/11.5743a28d.jpg";